import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import LocationList from "../Components/Location";
import "react-toastify/dist/ReactToastify.css";
import API from "../Services/AddPackage";
import ActivityList from "../Components/ActivityList";
import CenterModal from "../Components/CenterModal";
import TaxRateListList from "../Components/TaxRate";
import AddOnList from "../Components/AddOnList";

const AddOnActivity = () => {
    const [name, setName] = useState("");
    const [amount, setAmount] = useState("");
    const [logoPreview, setLogoPreview] = useState(null);
    const [image, setImage] = useState(null);
    const [error, setError] = useState({});
    const [locationId, setLocationId] = useState("");
    const [type, setType] = useState("");
    const [selectedCenter, setSelectedCenter] = useState([]);
    const [comboTax, setComboTax] = useState("")


    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        switch (fieldName) {
            case "name":
                setName(value);
                break;
            case "amount":
                setAmount(value);
                break;
            case "type":
                setType(value);
                break;
            case "locationId":
                setLocationId(value);
                break;
            default:
                break;
        }
    };

    const handleLogoChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const allowedFormats = ["image/jpeg", "image/png", "image/gif"];
            const maxSize = 5 * 1024 * 1024;

            if (!allowedFormats.includes(file.type)) {
                toast.error("Only JPG, PNG, and GIF formats are allowed.");
                return;
            }

            if (file.size > maxSize) {
                toast.error("File size must be 5MB or smaller.");
                return;
            }

            setError((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors.image;
                return updatedErrors;
            });

            setImage(file);
            setLogoPreview(URL.createObjectURL(file));
        }
    };

    const validateFields = () => {
        const newErrors = {};

        if (!selectedCenter) newErrors.selectedCenter = "Center is required.";
        if (!type.trim()) newErrors.type = "Type is required.";
        if (!name.trim()) newErrors.name = "Name is required.";
        if (!amount.trim()) newErrors.amount = "Amount is required.";
        if (!image) newErrors.image = "Image is required.";
        setError(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async () => {
        if (!validateFields()) return;
        await addActivity();
    };

    const handleCancel = () => {
        setName("");
        setAmount("");
        setImage(null);
        setLogoPreview(null);
        setLocationId("");
        setType("");
        setError({});
    };

    const addActivity = async () => {
        const location_id = Array.isArray(selectedCenter)
            ? selectedCenter.join(", ")
            : selectedCenter;
        const isMultiple = location_id.length === 1 ? 0 : 1;
        console.log("........", location_id)
        const formData = new FormData();
        formData.append("location_id", location_id);
        formData.append("name", name);
        formData.append("amount", amount);
        formData.append("type", type);
        formData.append("is_multiple", isMultiple);
        formData.append("tax_rate_id", comboTax);
        
        if (image instanceof File) {
            formData.append("image", image);
        }
        console.log('form data...', formData)
        try {
            const response = await API.addActivity(formData);
            console.log('response?.status',response?.status)
            if (response?.status === 200 || response?.status === 201) {
                toast.success(response?.data?.message || "Add-on product created successfully!");
               setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Failed to create activity.");
            }
        } catch (error) {
            if (error.response?.status === 403) {
                window.location.replace("/Login");
            }
            toast.error(error.message);
        }
    };

    const handleSelectedCenter = (selectedData) => {
        setSelectedCenter(selectedData);
    };

    return (
        <div>
            <div className="col-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title">AddOn</h4>
                        <div className="forms-sample">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group">
                                        {/* <LocationList
                                            selectedLocation={locationId}
                                            label="Center"
                                            isRequired={false}
                                            setSelectedLocation={(location) => {
                                                setLocationId(location);
                                                if (location.trim()) {
                                                    setError((prevErrors) => {
                                                        const updatedErrors = { ...prevErrors };
                                                        delete updatedErrors.locationId;
                                                        return updatedErrors;
                                                    });
                                                }
                                            }}
                                        />
                                        {error?.locationId && <span className="text-danger">{error.locationId}</span>} */}
                                        <CenterModal onSelectCenter={handleSelectedCenter} />
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>
                                            Type <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <select
                                            className="form-select"
                                            value={type}
                                            onChange={(e) => handleFieldChange(e, "type")}
                                        >
                                            <option value="">Select Type</option>
                                            <option value="service">Service</option>
                                            <option value="product">Product</option>
                                        </select>
                                        {error?.type && <span className="text-danger" style={{"font-size":"12px"}}>{error.type}</span>}
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>
                                            Name <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Name"
                                            value={name}
                                            onChange={(e) => handleFieldChange(e, "name")}
                                        />
                                        {error?.name && <span className="text-danger" style={{"font-size":"12px"}}>{error.name}</span>}
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-3">
                                    <TaxRateListList selectedTaxRate={comboTax} setSelectedTaxRate={setComboTax}
                                        taxRates={comboTax}
                                    />

                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>
                                            Price <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Amount"
                                            value={amount}
                                            onChange={(e) => handleFieldChange(e, "amount")}
                                        />
                                        {error?.amount && <span className="text-danger">{error.amount}</span>}
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <label>
                                        Upload Icon <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        accept="image/png, image/gif, image/jpeg"
                                        onChange={handleLogoChange}
                                    />
                                    {error?.image && <span className="text-danger">{error.image}</span>}
                                </div>

                                <div className="col-md-3">
                                    {logoPreview && (
                                        <div className="mt-2">
                                            <img
                                                src={logoPreview || 'No Image Available'}
                                                alt="Logo Preview"
                                                style={{ width: 100, height: 100, objectFit: "cover" }}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="mt-3">
                                <button onClick={handleSubmit} type="button" className="btn btn-primary me-3">
                                    Submit
                                </button>
                                <button onClick={handleCancel} className="btn btn-light">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ActivityList />
            <ToastContainer />
        </div>
    );
};

export default AddOnActivity;
